import React from "react";

export default class WebCnDesc extends React.Component {
  render() {
    const { Bs, VARIANT, dataCN, changedDesc } = this.props;
    return (
      <>
        {dataCN && (
          <Bs col xs={12} className="mb-4">
            <Bs row className="mb-2">
              <Bs b>Popis</Bs>
            </Bs>
            <Bs row>
              <Bs col xs={12}>
                {changedDesc && (
                  <Bs
                    formcontrol
                    as="textarea"
                    rows={3}
                    isInvalid={true}
                    autofocus="autofocus"
                    value={dataCN[0].QuotationDesc}
                    onChange={(e) => this.props.changeDescCn(e.target.value)}
                  />
                )}
                {!changedDesc && (
                  <Bs
                    formcontrol
                    as="textarea"
                    rows={3}
                    isValid={true}
                    autofocus="autofocus"
                    value={dataCN[0].QuotationDesc}
                    onChange={(e) => this.props.changeDescCn(e.target.value)}
                  />
                )}
              </Bs>
            </Bs>
          </Bs>
        )}
      </>
    );
  }
}
